import React from 'react';
import cx from "classnames";
import Icon from '../../common/components/Icon/Icon';

const LoadingSpinner = () => {
    return (
        <div className={cx("loading-spinner text-align--center")}>
            <Icon
                alt="Spinner Icon"
                className={cx("spinner")}
                size="3xl"
                id="Spinner"
            />
            <div className={cx("layout-flex-column text-align-left")}>
                <h1>Preparing your application</h1>
            </div>
        </div>
    );
};

export default LoadingSpinner;